var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBowlineLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363a3f;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 169,
    height: 169,
    rx: 84.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.4,69.73A6.69,6.69,0,0,1,84,63.35a36.84,36.84,0,0,1,5.91-.45,33.91,33.91,0,0,1,16.24,3.87,27.85,27.85,0,0,1,11.45,11.67q4.23,7.8,4.22,19.47t-4.43,19.68A28.32,28.32,0,0,1,105,129.4a41.15,41.15,0,0,1-18.48,3.93,46.47,46.47,0,0,1-14-1.89A44.81,44.81,0,0,1,62.48,127a15.38,15.38,0,0,1-4.29-4.29,10.16,10.16,0,0,1-1.33-5.41v-73a8.64,8.64,0,0,1,8.64-8.64h0a8.64,8.64,0,0,1,8.65,8.64v71.87a19.48,19.48,0,0,0,5,2.32,22.61,22.61,0,0,0,7.24,1.06q8,0,12.86-5.34t4.85-16.31q0-11.1-4.78-16.17A16.44,16.44,0,0,0,86.8,76.68c-.41,0-.82,0-1.22,0a6.75,6.75,0,0,1-7.18-6.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowlineLogo);
export default __webpack_public_path__ + "static/media/bowline-logo.944f66277a2161536cc76d102b859481.svg";
export { ForwardRef as ReactComponent };